import React from 'react'
import { useStyles } from './styles'
import { AppButton } from '@/shared/ui/button'
import ButtonWrapper from '../buttonWrapper'
import { Glow } from '../glow'
import { useHideNav } from '@/shared/hooks/useHideNav'

type EventScreenTemplateProps = {
  bgImage: string
  heading: string
  description: string | string[] | React.ReactNode
  content?: React.ReactNode
  notation?: string | React.ReactNode
  btnText: string
  onClick: () => void
  contentBgColor: string
  contentStyles?: React.CSSProperties
  bgImageStyles?: React.CSSProperties
  secondImageSrc?: string
  secondImageStyles?: React.CSSProperties
  thirdImageSrc?: string
  thirdImageStyles?: React.CSSProperties
  glowStyles?: React.CSSProperties
  backdrop?: boolean
}

export const EventScreenTemplate = (props: EventScreenTemplateProps) => {
  useHideNav()
  const {
    bgImage,
    heading,
    description,
    content,
    onClick,
    notation,
    btnText,
    contentBgColor,
    contentStyles,
    glowStyles,
    bgImageStyles,
    secondImageSrc,
    secondImageStyles,
    thirdImageSrc,
    thirdImageStyles,
    backdrop,
    ...styles
  } = props

  const { classes } = useStyles()

  return (
    <div
      className={classes.root}
      style={styles}
    >
      {glowStyles && <Glow {...glowStyles} />}

      <img
        src={bgImage}
        alt=""
        className={classes.newsImage}
        style={bgImageStyles}
      />

      {secondImageSrc && (
        <img
          src={secondImageSrc}
          alt=""
          style={{
            ...secondImageStyles,
          }}
        />
      )}

      {thirdImageSrc && (
        <img
          src={thirdImageSrc}
          alt=""
          style={{
            ...thirdImageStyles,
          }}
        />
      )}

      <div
        className={classes.contentWrapper}
        style={{
          background: contentBgColor ? contentBgColor : 'black',
          backdropFilter: backdrop ? 'blur(20px)' : '',
          ...contentStyles,
        }}
      >
        <div className={classes.headingAndDescriptionWrapper}>
          <h1>{heading}</h1>
          <span className={classes.description}>{description}</span>
        </div>
        {content}
        {notation && <span className={classes.notation}>{notation}</span>}
      </div>
      <ButtonWrapper
        startColor="#00000000"
        endColor="#000000"
      >
        <AppButton
          variant="primary"
          size="large"
          className={classes.button}
          onClick={onClick}
        >
          {btnText}
        </AppButton>
      </ButtonWrapper>
    </div>
  )
}
